export default __webpack_public_path__ + "static/media/events.0e8a5b43.svg";